module.exports = __webpack_public_path__ + "static/media/irisCityLogo.5784c4bb.png";